import React, { useState } from 'react';
import { useEditor } from '../../../contexts/EditorContext';

const SHAPE_CATALOG = [
  // ── Lines & Arrows ───────────────────────────────────────────────
  {
    id: 'line-solid',   label: 'Line',        category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <line x1="6" y1="20" x2="54" y2="20" stroke="#64748b" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
    defaults: { type: 'line-shape', length: 200, stroke: '#475569', strokeWidth: 4, dash: [] },
  },
  {
    id: 'line-dashed',  label: 'Dashed',      category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <line x1="6" y1="20" x2="54" y2="20" stroke="#64748b" strokeWidth="3" strokeLinecap="round" strokeDasharray="8 5"/>
      </svg>
    ),
    defaults: { type: 'line-shape', length: 200, stroke: '#475569', strokeWidth: 4, dash: [20, 12] },
  },
  {
    id: 'line-dotted',  label: 'Dotted',      category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <line x1="6" y1="20" x2="54" y2="20" stroke="#64748b" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 6"/>
      </svg>
    ),
    defaults: { type: 'line-shape', length: 200, stroke: '#475569', strokeWidth: 4, dash: [4, 12] },
  },
  {
    id: 'arrow',        label: 'Arrow',       category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <line x1="6" y1="20" x2="44" y2="20" stroke="#64748b" strokeWidth="3" strokeLinecap="round"/>
        <polygon points="44,12 54,20 44,28" fill="#64748b"/>
      </svg>
    ),
    defaults: { type: 'arrow-shape', length: 200, stroke: '#475569', strokeWidth: 4, fill: '#475569', pointerLength: 20, pointerWidth: 16 },
  },
  {
    id: 'double-arrow',  label: 'Dbl Arrow',   category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <polygon points="6,20 16,12 16,28" fill="#64748b"/>
        <line x1="16" y1="20" x2="44" y2="20" stroke="#64748b" strokeWidth="3" strokeLinecap="round"/>
        <polygon points="54,20 44,12 44,28" fill="#64748b"/>
      </svg>
    ),
    defaults: { type: 'arrow-shape', length: 200, stroke: '#475569', strokeWidth: 4, fill: '#475569', pointerLength: 20, pointerWidth: 16, pointerAtBeginning: true },
  },
  {
    id: 'wavy-line',     label: 'Wavy',        category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <path d="M6 20 Q14 10 22 20 Q30 30 38 20 Q46 10 54 20" stroke="#64748b" strokeWidth="3" fill="none" strokeLinecap="round"/>
      </svg>
    ),
    defaults: { type: 'wavy-line', length: 200, stroke: '#475569', strokeWidth: 4, amplitude: 15, frequency: 4 },
  },
  {
    id: 'curved-arrow',  label: 'Curve Arr',   category: 'Lines',
    preview: (
      <svg viewBox="0 0 60 50" fill="none">
        <path d="M8 38 Q30 8 52 38" stroke="#64748b" strokeWidth="3" fill="none" strokeLinecap="round"/>
        <polygon points="52,38 43,30 45,42" fill="#64748b"/>
      </svg>
    ),
    defaults: { type: 'curved-arrow', width: 200, height: 120, stroke: '#475569', strokeWidth: 4 },
  },

  // ── Shapes ───────────────────────────────────────────────────────
  {
    id: 'triangle',     label: 'Triangle',    category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="30,6 54,52 6,52" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'triangle', radius: 90, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'star',         label: 'Star',        category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="30,4 35,22 54,22 39,33 44,52 30,41 16,52 21,33 6,22 25,22" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'star', numPoints: 5, outerRadius: 90, innerRadius: 36, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'diamond',      label: 'Diamond',     category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="30,4 56,30 30,56 4,30" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'diamond', radius: 90, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'pentagon',     label: 'Pentagon',    category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="30,4 56,23 46,54 14,54 4,23" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'pentagon', radius: 90, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'hexagon',      label: 'Hexagon',     category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="30,4 53,17 53,43 30,56 7,43 7,17" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'hexagon', radius: 90, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'cross',        label: 'Cross',       category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <rect x="22" y="4"  width="16" height="52" rx="2" fill="#94a3b8"/>
        <rect x="4"  y="22" width="52" height="16" rx="2" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'cross', width: 160, height: 160, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'heart',        label: 'Heart',       category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <path d="M30 50 C10 35, 4 20, 4 15 C4 8, 10 4, 17 4 C22 4, 27 7, 30 12 C33 7, 38 4, 43 4 C50 4, 56 8, 56 15 C56 20, 50 35, 30 50Z" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'heart', width: 160, height: 150, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'cloud',        label: 'Cloud',       category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 50" fill="none">
        <path d="M10 38 Q4 38 4 30 Q4 22 12 22 Q12 10 24 10 Q32 10 34 18 Q40 16 44 22 Q50 22 50 30 Q50 38 44 38Z" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'cloud', width: 220, height: 140, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'octagon',      label: 'Octagon',     category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="20,4 40,4 56,20 56,40 40,56 20,56 4,40 4,20" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'octagon', radius: 90, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'star6',        label: '6-Point Star', category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <polygon points="30,4 36,20 54,20 40,30 46,48 30,38 14,48 20,30 6,20 24,20" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'star', numPoints: 6, outerRadius: 90, innerRadius: 45, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'ellipse',       label: 'Ellipse',     category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <ellipse cx="30" cy="20" rx="26" ry="14" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'ellipse', radiusX: 100, radiusY: 60, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'ring',          label: 'Ring',        category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <circle cx="30" cy="30" r="24" fill="#94a3b8"/>
        <circle cx="30" cy="30" r="12" fill="white"/>
      </svg>
    ),
    defaults: { type: 'ring', outerRadius: 80, innerRadius: 40, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'parallelogram', label: 'Parallel',    category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <polygon points="14,4 56,4 46,36 4,36" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'parallelogram', width: 200, height: 120, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'trapezoid',     label: 'Trapezoid',   category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <polygon points="12,4 48,4 56,36 4,36" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'trapezoid', width: 200, height: 120, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'chevron',       label: 'Chevron',     category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 40" fill="none">
        <polygon points="4,4 46,4 56,20 46,36 4,36 14,20" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'chevron', width: 200, height: 120, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'shield',        label: 'Shield',      category: 'Shapes',
    preview: (
      <svg viewBox="0 0 50 60" fill="none">
        <path d="M6 6 L44 6 Q48 6 48 12 L48 34 Q48 50 25 58 Q2 50 2 34 L2 12 Q2 6 6 6Z" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'shield', width: 160, height: 180, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'callout',       label: 'Callout',     category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <rect x="4" y="4" width="52" height="36" rx="4" fill="#94a3b8"/>
        <polygon points="12,40 18,56 26,40" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'callout', width: 200, height: 160, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'crescent',      label: 'Crescent',    category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 60" fill="none">
        <path d="M36 6 C54 10 54 50 36 54 C24 50 18 40 18 30 C18 20 24 10 36 6Z" fill="#94a3b8"/>
        <path d="M36 6 C48 12 48 48 36 54 C28 50 24 40 24 30 C24 20 28 10 36 6Z" fill="white"/>
      </svg>
    ),
    defaults: { type: 'crescent', radius: 80, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
  {
    id: 'ribbon',        label: 'Ribbon',      category: 'Shapes',
    preview: (
      <svg viewBox="0 0 60 30" fill="none">
        <polygon points="4,4 56,4 50,15 56,26 4,26 10,15" fill="#94a3b8"/>
      </svg>
    ),
    defaults: { type: 'ribbon', width: 200, height: 80, fill: '#94a3b8', stroke: '', strokeWidth: 0 },
  },
];

const CATEGORIES = ['Lines', 'Shapes'];

const ElementsPanel = () => {
  const { addElement, dimensions } = useEditor();
  const [search, setSearch] = useState('');

  const cx = dimensions.width / 2;
  const cy = dimensions.height / 2;

  const handleAdd = (item) => {
    const id = `${item.defaults.type}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    const isLinear = item.defaults.type === 'line-shape' || item.defaults.type === 'arrow-shape' || item.defaults.type === 'wavy-line';
    addElement({
      ...item.defaults,
      id,
      x: isLinear ? cx - (item.defaults.length || 200) / 2 : cx,
      y: cy,
      rotation: 0,
      opacity: 1,
    });
  };

  const filtered = SHAPE_CATALOG.filter(item =>
    item.label.toLowerCase().includes(search.toLowerCase()) ||
    item.category.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex-1 bg-white flex flex-col overflow-hidden">
      {/* Search */}
      <div className="p-2 border-b border-gray-200 shrink-0">
        <input
          type="text"
          placeholder="Search shapes…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-2 py-1.5 border border-gray-200 rounded text-xs focus:outline-none focus:border-blue-400"
        />
      </div>

      {/* Shape list */}
      <div className="flex-1 overflow-y-auto p-2">
        {CATEGORIES.map(cat => {
          const items = filtered.filter(i => i.category === cat);
          if (items.length === 0) return null;
          return (
            <div key={cat} className="mb-4">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 px-1">{cat}</p>
              <div className="grid grid-cols-4 gap-1.5">
                {items.map(item => (
                  <button
                    key={item.id}
                    onClick={() => handleAdd(item)}
                    title={`Add ${item.label}`}
                    className="flex flex-col items-center gap-1 p-1.5 rounded-lg border border-transparent hover:border-blue-300 hover:bg-blue-50 transition-colors group"
                  >
                    <div className="w-12 h-12 flex items-center justify-center">
                      {item.preview}
                    </div>
                    <span className="text-xs text-gray-500 group-hover:text-blue-600 leading-tight text-center truncate w-full">
                      {item.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ElementsPanel;
